import React from 'react'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import firebase from 'firebase'
import { Button, CardActions } from '@material-ui/core'


export const Entry = ({username, text, deleteEntry, id }) => {
  const isUser = username === text.username

  return (
    <div>
      <Card>
        <CardContent className='entry__text'>
          <Typography id='entry__text' color='white'>
            {text.text}
          </Typography>
        </CardContent>
      </Card>
      <Button
        onClick={ () => deleteEntry(id)}
        >
          Delete
        </Button>
    </div>
  )
}
